<template>

    <div class="content-load">

        <Top></Top>
        <!-- Dashboard Container -->
        <div class="dashboard-container">

            <Sidebar></Sidebar>

            <!-- Dashboard Content
            ================================================== -->
            <div class="dashboard-content-container">
                <div class="dashboard-content-inner" >
                    <div class="header-image-gradient" style="background-image: url(static/images/img4.jpg); opacity: 0.9;">
                        <div class="layer-gradient" style="background: linear-gradient(to bottom, rgba(255,255,255,0.1), rgba(255,255,255,1));"></div>
                    </div>                

                    <!-- Dashboard Headline -->
                    <div class="dashboard-headline hidden-xs">
                        <h3>
                            {{$router.currentRoute.meta.title}}
                        </h3>
                    </div>
                        
                    <!-- Row -->
                    <div class="row"> 
                        <div class="col-xs-12">
                            <h5 class="center">
                                A Clínica de Neoplasias Litoral trabalha em <b>parceria</b> com <b>diversos convênios</b>, para oferecer aos nossos pacientes maior <b>facilidade</b> ao realizar seu tratamento.
                                <br><br>
                                Verifique abaixo se seu convênio está listado e <b>faça o agendamento</b> da sua consulta!
                            </h5>
                        </div>

                        <div class="col-xs-6 col-xl-4 col-lg-4 col-md-4">
                            <img src="/static/images/convenios/unafisco.png">
                        </div>
                        <div class="col-xs-6 col-xl-4 col-lg-4 col-md-4">
                            <img src="/static/images/convenios/temposaude.png">
                        </div>
                        <div class="col-xs-6 col-xl-4 col-lg-4 col-md-4">
                            <img src="/static/images/convenios/scsaude.png">
                        </div>                               
                        <div class="col-xs-6 col-xl-4 col-lg-4 col-md-4">
                            <img src="/static/images/convenios/sicoob.png">
                        </div>
                        <div class="col-xs-6 col-xl-4 col-lg-4 col-md-4">
                            <img src="/static/images/convenios/postalsaude.png">
                        </div>                                                                                                                         
                        <div class="col-xs-6 col-xl-4 col-lg-4 col-md-4">
                            <img src="/static/images/convenios/pladisa.png">
                        </div>
                        <div class="col-xs-6 col-xl-4 col-lg-4 col-md-4">
                            <img src="/static/images/convenios/petrobras.jpg">
                        </div>
                        <div class="col-xs-6 col-xl-4 col-lg-4 col-md-4">
                            <img src="/static/images/convenios/renner.jpg">
                        </div>
                        <div class="col-xs-6 col-xl-4 col-lg-4 col-md-4">
                            <img src="/static/images/convenios/saudeconceicao.jpg">
                        </div>
                        <div class="col-xs-6 col-xl-4 col-lg-4 col-md-4">
                            <img src="/static/images/convenios/saudecaixa.jpg">
                        </div>
                        <div class="col-xs-6 col-xl-4 col-lg-4 col-md-4">
                            <img src="/static/images/convenios/sulamericasaude.jpg">
                        </div>
                        <div class="col-xs-6 col-xl-4 col-lg-4 col-md-4">
                            <img src="/static/images/convenios/unimed.jpg">
                        </div>     
                        <div class="col-xs-6 col-xl-4 col-lg-4 col-md-4">
                            <img src="/static/images/convenios/vonpar.jpg">
                        </div>                              
                        <div class="col-xs-6 col-xl-4 col-lg-4 col-md-4">
                            <img src="/static/images/convenios/elosaude.png">
                        </div>
                        <div class="col-xs-6 col-xl-4 col-lg-4 col-md-4">
                            <img src="/static/images/convenios/paranaclinicassaude.png">
                        </div>
                        <div class="col-xs-6 col-xl-4 col-lg-4 col-md-4">
                            <img src="/static/images/convenios/marinhadobrasil.jpg">
                        </div>
                        <div class="col-xs-6 col-xl-4 col-lg-4 col-md-4">
                            <img src="/static/images/convenios/medservice.jpg">
                        </div>
                        <div class="col-xs-6 col-xl-4 col-lg-4 col-md-4">
                            <img src="/static/images/convenios/goldencross.jpg">
                        </div>
                        <div class="col-xs-6 col-xl-4 col-lg-4 col-md-4">
                            <img src="/static/images/convenios/gamasaude.jpg">
                        </div>
                        <div class="col-xs-6 col-xl-4 col-lg-4 col-md-4">
                            <img src="/static/images/convenios/geapsaude.jpg">
                        </div>
                        <div class="col-xs-6 col-xl-4 col-lg-4 col-md-4">
                            <img src="/static/images/convenios/funservir.jpg">
                        </div>
                        <div class="col-xs-6 col-xl-4 col-lg-4 col-md-4">
                            <img src="/static/images/convenios/eletrosul.jpg">
                        </div>
                        <div class="col-xs-6 col-xl-4 col-lg-4 col-md-4">
                            <img src="/static/images/convenios/cassi.jpg">
                        </div>
                        <div class="col-xs-6 col-xl-4 col-lg-4 col-md-4">
                            <img src="/static/images/convenios/capesep.jpg">
                        </div>
                        <div class="col-xs-6 col-xl-4 col-lg-4 col-md-4">
                            <img src="/static/images/convenios/bradescosaude.jpg">
                        </div>
                        <div class="col-xs-6 col-xl-4 col-lg-4 col-md-4">
                            <img src="/static/images/convenios/fundacaoassefaz.jpg">
                        </div>
                        <div class="col-xs-6 col-xl-4 col-lg-4 col-md-4">
                            <img src="/static/images/convenios/aspmi.jpg">
                        </div>
                        <div class="col-xs-6 col-xl-4 col-lg-4 col-md-4">
                            <img src="/static/images/convenios/amil.jpg">
                        </div>
                        <div class="col-xs-6 col-xl-4 col-lg-4 col-md-4">
                            <img src="/static/images/convenios/celos.png">
                        </div>
                        <div class="col-xs-6 col-xl-4 col-lg-4 col-md-4">
                            <img src="/static/images/convenios/cabergssaude.png">
                        </div>  
                        <div class="col-lg-12 margin-bottom-15 margin-top-20" v-if="$root.user.tipo == 'contratante'">
                            <router-link :to="{'name': 'Profissionais'}" class="button block-mobile color-secondary">
                                <i class="material-icons">add</i>
                                Quero fazer um agendamento
                            </router-link>
                        </div>                        
                    </div>
                </div>
            </div>
        </div>
        <Toolbar></Toolbar>

    </div>
</template>

<script>
import Top from './Top'
import Toolbar from './Toolbar'
import Sidebar from './Sidebar'

export default {
    name:                           'Convenios',
    components: {
        'Top':                      Top,
        'Sidebar':                  Sidebar,
        'Toolbar':                  Toolbar
    },       
    filters: {
        formatDate: function(value) {
            if (!value) {
                return "";
                return false;
            }
            var d = value.split(" ");
            var date = d[0];
            var time = d[1];
            d = date.split("-");
            date = d[2] + "/" + d[1] + "/" + d[0];
            d = time.split(":");
            time = d[0] + ":" + d[1];

            return date + " " + time;
        },
        toMoney: function(value) {
            if (value) {
                return parseFloat(value).toLocaleString('pt-br', {minimumFractionDigits: 2})                
            } else {
                return "0,00";
            }
        },        
    },    
    data () {
        var self                    = this;
        return {
            "loaded":               false,
            "visualizar": {
                "itens":            []
            },
            "data":                 {
                "itens":            []
            },
            "loading": {
                "submit":           false
            },           
            "form": {
                "_cod":             self.$root.user.cod,
                "_token":           self.$root.user.token
            },
        }
    },
    watch: {
                  
    },
    methods: {                  
        get: function() {
            var self        = this;
            console.log("get()");
            return new Promise(function(resolve, reject) {

                var form = {
                    "params": {
                        "_cod":         self.$root.user.cod, 
                        "_token":       self.$root.user.token
                    }
                };

                axios.get("api/arquivos.php", form)
                .then(response => {
                    
                    console.log("get() response", response);
                    self.data           = response.data.result;
                    resolve(response.data.result);
  
                })
                .catch(error => {
                    console.log("get() error", error);                    
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                   
                });   
            });   
        }
    },
    created: function() {
        var self = this;

        // loading.show();

        // Promise.all([
        //     self.get()
        // ]).then(function() {
        
        //     self.$forceUpdate();
        //     loading.hide();
            
        // }).catch(function(error) {
            loading.hide();
        // });         

    },
    mounted: function() {
    }    
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .col-xs-6 img {
        width: 100%;
    }
    h5 {
        line-height: 130%;
        color: #333;
        font-weight: 400;
        margin-bottom: 20px;
    }
</style>



// WEBPACK FOOTER //
// src/components/Convenios.vue